<template>
  <Modal v-model="loginModal" :close="() => { setModal(false) }">
    <div class="lcu-modal">
      <div class="row">
        <p class="lcu-center-text">
          Debes iniciar sesión para ver este contenido.
        </p>
      </div>
      <div class="lcu-modal-5050Buttons">
        <button-cta
          :text="'No estás inscrito? Haz clic aquí'"
          :type="'secondary'"
          @on-click="goToEnroll" />
        <button-cta
          :text="'Iniciar Sesión'"
          @on-click="goToLogin" />
      </div>
    </div>
  </Modal>
</template>

<script>
import ButtonCta from 'ç/buttons/Cta.vue';

export default {
  name: 'login-modal',
  components: {
    ButtonCta,
  },
  props: ['login-modal'],
  methods: {
    goToLogin() {
      this.$router.push('/iniciar-sesion');
    },
    goToEnroll() {
      this.$router.push('/inscribirse');
    },
    setModal(val) {
      this.$emit('set-modal', val);
    },
  },
};
</script>
